import { IProjects } from "../interfaces/IProjects";

export const projects: IProjects[] = [
  {
    image: "",
    link: "https://spotify-summary.netlify.app/",
    title: "Spotify Top Track Generator",
    Description:
      "Spotify-Summary is a simple Spotify stat tracker built with React. It dives into the Spotify API to fetch listening history and top tracks, giving insights into handling and visualizing large datasets within a React application.",
  },
  {
    image: "",
    link: "https://husainscloudsave.netlify.app/",
    title: "Cloud Save",
    Description:
      "A personal game diary built with React and TypeScript, backed by Supabase. Track games across queued, playing, and finished states, with RAWG.io integration for searching and adding titles.",
  },
  {
    image: "",
    link: "https://vinyl-randomizer.netlify.app/",
    title: "Vinyl Randomizer",
    Description:
      "A randomizer integrated with my Discogs library that picks a random record from my collection.",
  },
];
